module.exports = __webpack_public_path__ + "static/media/client-uber.fdf3a90e.png";